import { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { CompatibilityLazy } from 'src/lands/compatibility';
import { Q2025Layout, quiz2025RouteList } from 'src/quizzes/2025';
import { q_CompatibilityLongRoutes } from 'src/quizzes/compatibility-long/config/routes';
import { Q_CompatibilityLong } from 'src/quizzes/compatibility-long/pages/q_compatibility-long';
import { Fallback } from 'src/quizzes/compatibility-long/shared/ui/fallback/fallback';
import { q_CompatibilityShortRoutes } from 'src/quizzes/compatibility-short/config/routes';
import { Q_CompatibilityShort } from 'src/quizzes/compatibility-short/pages/q_compatibility-short';
import { Fallback as CompatibilityLongFallBack } from 'src/quizzes/compatibility-short/shared/ui/fallback/fallback';

import DateBirthApp from '../apps/date-birth/components/app/app';
import { routes as routesDateBirth } from '../apps/date-birth/routes';
import FutureApp from '../apps/future/components/app/app';
import { routes as routesFuture } from '../apps/future/routes';
import MessengerApp from '../apps/messenger/App';
import TarotApp from '../apps/tarot/components/app/app';
import { routes as routesTarot } from '../apps/tarot/routes';
import TarotChatApp from '../apps/tarot-chat/App';
import WitchApp from '../apps/witch/components/app/app';
import { routes as routesWitch } from '../apps/witch/routes';
import { PopeLand } from '../lands/pope';
import { VangaLandLazy } from '../lands/vanga';

export const App = () => {
  return (
    <Routes>
      <Route
        path="vanga"
        element={
          <Suspense fallback="">
            <VangaLandLazy />
          </Suspense>
        }
      />
      <Route
        path="compatibility-short"
        element={
          <Suspense fallback={<Fallback />}>
            <CompatibilityLazy version="short" />
          </Suspense>
        }
      />
      <Route
        path="compatibility-long"
        element={
          <Suspense fallback={<CompatibilityLongFallBack />}>
            <CompatibilityLazy version="long" />
          </Suspense>
        }
      />

      <Route
        path="q-compatibility-short"
        element={
          <Suspense fallback={<Fallback />}>
            <Q_CompatibilityShort />
          </Suspense>
        }
      >
        {q_CompatibilityShortRoutes}
      </Route>

      <Route
        path="q-compatibility-long"
        element={
          <Suspense fallback={<CompatibilityLongFallBack />}>
            <Q_CompatibilityLong />
          </Suspense>
        }
      >
        {q_CompatibilityLongRoutes}
      </Route>

      <Route path="2025quiz" element={<Q2025Layout />}>
        {quiz2025RouteList}
      </Route>

      {/* <Route path="compatibility-long" element={<CompatibilityLongApp />}>
        {routesCompatibilityLong}
      </Route>

      <Route path="compatibility-short" element={<CompatibilityShortApp />}>
        {routesCompatibilityShort}
      </Route> */}

      <Route path="date-birth" element={<DateBirthApp />}>
        {routesDateBirth}
      </Route>

      <Route path="messenger" element={<MessengerApp />} />

      <Route path="tarot" element={<TarotApp />}>
        {routesTarot}
      </Route>

      <Route path="tarot-chat" element={<TarotChatApp />} />

      <Route path="witch" element={<WitchApp />}>
        {routesWitch}
      </Route>

      <Route path="future" element={<FutureApp />}>
        {routesFuture}
      </Route>

      <Route path="pope-short" element={<PopeLand version="short" />}></Route>
      <Route path="pope-long" element={<PopeLand version="long" />}></Route>
    </Routes>
  );
};
